import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(ButtonBase)(({ theme, active }) => ({
  padding: theme.spacing(1.5, 2),
  width: '100%',
  borderRadius: 4,
  border: '1px solid',
  borderColor: active ? theme.palette.primary.main : theme.palette.divider[5],
  flexDirection: 'column',
  alignItems: 'flex-start',
  '&:hover': {
    borderColor: !active && theme.palette.common.white,
    backgroundColor: !active && theme.palette.divider[5],
  },
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    '& .MuiTypography-root, .TBWPerPersonPrice': {
      color: theme.palette.text.disabled,
    },
  },
  '& .TBWPerPersonPrice': {
    color: theme.palette.common.white,
  },
  '& .TPRChip': {
    padding: theme.spacing(0.5, 0.75),
    backgroundColor: theme.palette.divider[4],
    marginRight: theme.spacing(1.5),
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    opacity: 0.9,
    '&:last-child': {
      marginRight: 0,
    },
    '& .TPRChipText': {
      lineHeight: 'normal',
      fontSize: theme.typography.pxToRem(14),
      textTransform: 'lowercase',
    },
  },
  '& .TPRPackageName': {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: '150%',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
  '& .TPRSeaterBadge': {
    backgroundColor: theme.palette.background.primary,
    color: theme.palette.primary.main,
    borderRadius: 4,
    padding: theme.spacing(0.25, 1),
    fontSize: theme.typography.pxToRem(10),
    fontWeight: 700,
    display: 'inline-block',
    marginLeft: theme.spacing(1.25),
    lineHeight: '150%',
  },
}));

export default StyledBox;
